/**
 * Whether phases drive a workflow: auto-start, auto-complete and board column
 * moves. A workflow with at most one task phase is a plain list of tasks whose
 * column is the user's to move. It becomes phased once it has two phases, or
 * once any phase is a signing phase, since signing runs on its own lifecycle.
 *
 * The server reads `isSigning` off the row and the client reads `__typename`,
 * so each caller says how to spot a signing phase.
 */
export function getIsWorkflowPhased<TPhase>(
  phases: readonly TPhase[],
  getIsSigning: (phase: TPhase) => boolean
): boolean {
  return phases.length > 1 || phases.some(getIsSigning);
}

/**
 * Whether a task in an active phase starts without anyone pressing Start. On a
 * phased workflow every task does. On a phaseless one only a task delegated to
 * Aline AI does, since delegating is the go signal; a person's task waits.
 */
export function getStartsInActivePhase<TPhase>(
  task: { isDelegatedToAi: boolean },
  options: { getIsSigning: (phase: TPhase) => boolean; phases: readonly TPhase[] }
): boolean {
  return task.isDelegatedToAi || getIsWorkflowPhased(options.phases, options.getIsSigning);
}
